import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IStateNetwork } from './type'
import { INetwork } from 'services/type'

const initialState: IStateNetwork = {
  networks: [],
}

export const networkSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setNetworks: (
      state: IStateNetwork,
      action: PayloadAction<Array<INetwork>>
    ) => {
      state.networks = action.payload
    },
  },
})

export const { setNetworks } = networkSlice.actions

export default networkSlice.reducer
